"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const keautils_1 = require("keautils");
const observe_1 = require("./observe");
const _moize = require("moize");
const moize = keautils_1.interopRequireDefault(_moize);
/**Obtiene un resource del actual this. Si no se realizo el bind correctamente devuelve un error */
function getResourceFromThis(_this) {
    //Verificar que este bien aplicado el bindResource
    if (_this == null || _this.bindedResource != _this) {
        throw new Error("Se debe de aplicar bindResource al final de la composición de un resource");
    }
    return _this;
}
exports.getResourceFromThis = getResourceFromThis;
/**Devuelve un nuevo resource donde se aplica Function.bind(source) para cada uno de sus miembros. Este paso es importante de aplicar después de la composición de un
 *  resource ya que las funciones del resource ocupan una correcta referencia al this para
 * que pueda funcionar la invalidación del cache.
 *
 * El resource original no es modificado */
function bindResource(resource) {
    const ret = {};
    for (const key in resource) {
        const value = resource[key];
        const bindValue = (typeof value == "function") ? keautils_1.bindFunction(keautils_1.unbindFunction(value) || value, ret) : value;
        bindValue.bindedResource = ret;
        ret[key] = bindValue;
    }
    ret.bindedResource = ret;
    ret.createObservable = moize(observe_1.observeResourceNoMemo, { maxSize: 128 });
    return ret;
}
exports.bindResource = bindResource;
//# sourceMappingURL=bind.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kea-resource/dist/cache/bind.js
// module id = 302
// module chunks = 0